 //https://github.com/custom-select/custom-select

import customSelect from 'custom-select';

// Gestion des selects

var cstSelNav
var cstSelPage
export var currentTheme

export var page = '';

export function removeSelect() {
  cstSelNav.destroy()
  cstSelPage.destroy()
 }

  export function initSelect() {      

    if (document.getElementById('select-theme-nav')) {
      customSelect(document.getElementById('select-theme-nav'));
      cstSelNav =  document.getElementById('select-theme-nav').customSelect
     cstSelNav.select.addEventListener('change',
     (e) => { scrollTheme(cstSelNav.value);  });

    }
       

        customSelect(document.getElementById('select-theme-page'));
         cstSelPage =  document.getElementById('select-theme-page').customSelect
        cstSelPage.select.addEventListener('change',
        (e) => { scrollTheme(cstSelPage.value);  });

          const threshold = .1
          const optionsSelect = {
            root: null,
            rootMargin: "0px 0px -90% 0px",
            threshold
          }

        const handleSections = function (entries, observer) {
            entries.forEach(function (entry) {
              if (entry.intersectionRatio > threshold) {

                 currentTheme = entry.target.dataset.id;
            
                cstSelNav.value = currentTheme;
                if ( document.querySelector('body.candidat') ) {
                     // Sélection du type de page active
                    if (document.querySelector('body.comparaison'))  page = '.zone-propositions-comparaison';
                    else if (document.querySelector('body.candidat'))  page = '.zone-propositions-candidat';
                    else if (document.querySelector('body.theme'))  page = '.zone-propositions-candidat';

                    if ( currentTheme != 'europe-et-international') {
                    
                      var nomTheme = document.querySelector(page+' .section-'+currentTheme).dataset.theme;

                      if (currentTheme == 'environnement') nomTheme = 'Environ-<br>nement'
                      document.querySelector('.bt-france .titre-xs').innerHTML = nomTheme;
                      document.querySelector('.bt-france').dataset.theme = currentTheme;
                    } 
                
                }
              }
            })
        }

        const observer = new IntersectionObserver(handleSections, optionsSelect)
        const targets = document.querySelectorAll('.section-theme-propositions')
        targets.forEach(function (target) {
          observer.observe(target)
        })


      selectHeight()


  }

  function scrollTheme(section) {
    //console.log(section);

       // Sélection du type de page active
       if (document.querySelector('body.comparaison'))  page = '.zone-propositions-comparaison';
       else if (document.querySelector('body.candidat'))  page = '.zone-propositions-candidat';
       else if (document.querySelector('body.theme'))  page = '.zone-propositions-candidat';


    const yOffset = -130;
    console.log(yOffset)
     console.log(page+' .section-'+section)
    const element = document.querySelector(page+' .section-'+section);
    console.log(element)
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({top: y, behavior: 'smooth'});
  }





  function selectHeight() {
    let hauteur = ( document.getElementById("select-theme-page").length * 36 ) + 20

    let panels = document.querySelectorAll('custom-select-panel')
    for (let i = 0; i < panels.length; i++) {
      panels[i].style.setProperty("--calc-height", hauteur+'px');
    }
  }

